import { urlValidation } from "../../../../components/forms/validator";
import { findDuplicates } from "../../../../utils";

export const urlsValidator = (value) => {
    const values = value?.split("\n").filter(item => item);

    const duplicates = values && values.length && findDuplicates(values);

    if(!values){
        return "1-5 URLs are required";
    }

    if(values.length > 5){
        return "Max urls should be less then 5";
    }

    if(duplicates.length){
        return `Url "${duplicates.join(", ")}" is duplicated. Please use unique examples`;
    }

    const urlMessage = values.reduce(
        (acc, item) => {
            const message = urlValidation(item);

            if(message){
                return message;
            }

            return acc;
        },
        null
    );

    if(urlMessage){
        return urlMessage;
    }

    return  undefined;
};
